import { notifyError, notifySuccess } from "@lib/helper"
import http from "../httpService"
import { L, LNotification } from "@lib/abpUtility"
import { PagedResultDto } from "@services/dto/pagedResultDto"
import { UnitModel } from "@models/project/unitModel"

class UnitMasterService {
  public async getAll(params: any): Promise<PagedResultDto<any>> {
    const res = await http.get("api/services/app/Unit/GetAll", {
      params,
    })
    const { result } = res.data

    return result
  }
  public async get(id: number): Promise<any> {
    if (!id) {
      notifyError(L("Error"), L("EntityNotFound"))
    }

    const res = await http.get(`api/services/app/Unit/Get`, {
      params: { id },
    })

    const { result } = res.data

    return UnitModel.assign(result)
  }

  public async create(body: any) {
    const result = await http.post(
      "api/services/app/Unit/CreateMasterData",
      body
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("SAVING_SUCCESSFULLY")
    )
    return result.data.result
  }
  public async update(body: any) {
    //body ignore other model

    // const filteredBody = ignoreBodyByModel(body, UnitUpdateMasterModel)

    const result = await http.put(
      `api/services/app/Unit/UpdateMasterData`,
      body
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("SAVING_SUCCESSFULLY")
    )
    return result.data.result
  }
  public async active(id: number, isActive) {
    const result = await http.post(
      "api/services/app/Unit/Active",
      { id },
      { params: { isActive } }
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("UPDATE_SUCCESSFULLY")
    )
    return result.data
  }

  public async getListFromTower(projectId: any): Promise<any> {
    if (!projectId) {
      notifyError(L("Error"), L("EntityNotFound"))
    }

    const res = await http.get(`api/services/app/Tower/GetListDetail`, {
      params: { projectId },
    })

    const { result } = res.data

    return result
  }

  // import
  public async import(file: File): Promise<any> {
    const formData = new FormData()
    formData.append("file", file)

    const result = await http.post("api/Imports/ImportUnit", formData, {
      headers: {
        "content-type": "multipart/form-data",
      },
    })

    return result.data.result
  }
}

export default new UnitMasterService()
